/* eslint-disable */
import React from 'react';
import { Grid, Paper, Typography, Box, Container, Divider } from '@material-ui/core';

const TermsOfUse = () => {
  return (
    <Grid container>
      <Grid item xs={12}>
        <Container maxWidth="lg" style={{ paddingTop: '40px', paddingBottom: '40px' }}>
          <Paper elevation={0} style={{ padding: '40px', backgroundColor: '#f9f9f9' }}>
            <Typography
              variant="h1"
              component="h1"
              style={{ marginBottom: '20px', textAlign: 'center' }}
            >
              Terms & Conditions
            </Typography>
            <Typography
              variant="body2"
              style={{ marginBottom: '30px', textAlign: 'center', fontStyle: 'italic' }}
            >
              Last Updated: [Date]
            </Typography>
            <Divider style={{ marginBottom: '30px' }} />

            <Typography
              variant="h5"
              component="h2"
              color="primary"
              style={{ marginBottom: '15px' }}
            >
              1. Acceptance of Terms
            </Typography>
            <Typography variant="body1" style={{ marginBottom: '25px', lineHeight: '1.6' }}>
              Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum
              has been the industry's standard dummy text ever since the 1500s, when an unknown
              printer took a galley of type and scrambled it to make a type specimen book.
            </Typography>

            <Typography
              variant="h5"
              component="h2"
              color="primary"
              style={{ marginBottom: '15px' }}
            >
              2. Description of Service
            </Typography>
            <Typography variant="body1" style={{ marginBottom: '25px', lineHeight: '1.6' }}>
              Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum
              has been the industry's standard dummy text ever since the 1500s, when an unknown
              printer took a galley of type and scrambled it to make a type specimen book.
            </Typography>

            <Typography
              variant="h5"
              component="h2"
              color="primary"
              style={{ marginBottom: '15px' }}
            >
              3. User Responsibilities
            </Typography>
            <Box component="ul" style={{ marginBottom: '25px', paddingLeft: '20px' }}>
              <Typography
                component="li"
                variant="body1"
                style={{ marginBottom: '8px', lineHeight: '1.6' }}
              >
                Lorem Ipsum is simply dummy text of the printing and typesetting industry.
              </Typography>
              <Typography
                component="li"
                variant="body1"
                style={{ marginBottom: '8px', lineHeight: '1.6' }}
              >
                Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem
                Ipsum has been the industry's standard dummy text ever since the 1500s.
              </Typography>
              <Typography
                component="li"
                variant="body1"
                style={{ marginBottom: '8px', lineHeight: '1.6' }}
              >
                Lorem Ipsum is simply dummy text of the printing and typesetting industry.
              </Typography>
            </Box>

            <Typography
              variant="h5"
              component="h2"
              color="primary"
              style={{ marginBottom: '15px' }}
            >
              4. Intellectual Property
            </Typography>
            <Typography variant="body1" style={{ marginBottom: '25px', lineHeight: '1.6' }}>
              Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum
              has been the industry's standard dummy text ever since the 1500s, when an unknown
              printer took a galley of type and scrambled it to make a type specimen book.
            </Typography>

            <Typography
              variant="h5"
              component="h2"
              color="primary"
              style={{ marginBottom: '15px' }}
            >
              5. Disclaimer of Warranties
            </Typography>
            <Typography variant="body1" style={{ marginBottom: '25px', lineHeight: '1.6' }}>
              Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum
              has been the industry's standard dummy text ever since the 1500s, when an unknown
              printer took a galley of type and scrambled it to make a type specimen book.
            </Typography>

            <Typography
              variant="h5"
              component="h2"
              color="primary"
              style={{ marginBottom: '15px' }}
            >
              6. Limitation of Liability
            </Typography>
            <Typography variant="body1" style={{ marginBottom: '25px', lineHeight: '1.6' }}>
              Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum
              has been the industry's standard dummy text ever since the 1500s, when an unknown
              printer took a galley of type and scrambled it to make a type specimen book.
            </Typography>

            <Typography
              variant="h5"
              component="h2"
              color="primary"
              style={{ marginBottom: '15px' }}
            >
              7. Third-Party Links
            </Typography>
            <Typography variant="body1" style={{ marginBottom: '25px', lineHeight: '1.6' }}>
              Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum
              has been the industry's standard dummy text ever since the 1500s, when an unknown
              printer took a galley of type and scrambled it to make a type specimen book.
            </Typography>

            <Typography
              variant="h5"
              component="h2"
              color="primary"
              style={{ marginBottom: '15px' }}
            >
              8. Changes to Terms
            </Typography>
            <Typography variant="body1" style={{ marginBottom: '25px', lineHeight: '1.6' }}>
              Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum
              has been the industry's standard dummy text ever since the 1500s, when an unknown
              printer took a galley of type and scrambled it to make a type specimen book.
            </Typography>

            <Typography
              variant="h5"
              component="h2"
              color="primary"
              style={{ marginBottom: '15px' }}
            >
              9. Governing Law
            </Typography>
            <Typography variant="body1" style={{ marginBottom: '25px', lineHeight: '1.6' }}>
              Lorem Ipsum is simply dummy text of the printing and typesetting industry.
            </Typography>

            <Typography
              variant="h5"
              component="h2"
              color="primary"
              style={{ marginBottom: '15px' }}
            >
              10. Contact Information
            </Typography>
            <Typography variant="body1" style={{ marginBottom: '10px', lineHeight: '1.6' }}>
              If you have any questions about these Terms, please contact us at:
            </Typography>
            <Typography variant="body1" style={{ marginBottom: '5px', lineHeight: '1.6' }}>
              Email: Lorem Ipsum is simply dummy text
            </Typography>
            <Typography variant="body1" style={{ lineHeight: '1.6' }}>
              Address: Lorem Ipsum is simply dummy text
            </Typography>
          </Paper>
        </Container>
      </Grid>
    </Grid>
  );
};

export default TermsOfUse;
